import axios from '../utils/axios';

export default function updateSeekerPhoneStatus (adminId, data) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/user/admin/change-phone-status`, data);
}